export const white = [0.92, 0.93, 0.92];
